import React from 'react';
import {SkeletonLoader} from 'components';

const InfoCard = ({title, value, isLoading}) => (
  <div className="bg-white rounded p-4 flex items-start gap-1 w-full flex-col">
    {isLoading ? (
      <>
        <SkeletonLoader style={{width: 100, height: 12, marginBottom: 10}} />
        <SkeletonLoader style={{width: 120, height: 12, marginBottom: 10}} />
      </>
    ) : (
      <>
        <p className="text-[#080917] text-[10px] font-normal uppercase">
          {title}
        </p>
        <p className="text-small font-normal text-[#4A4A68]">
          {value || 'N/A'}
        </p>
      </>
    )}
  </div>
);

export default InfoCard;
